var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"zqXsgfHaSoTrqtzMFJmJd"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  tracesSampleRate: process.env.NEXT_PUBLIC_APP_ENV === "test" ? 1.0 : 0.5,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate:
    process.env.NEXT_PUBLIC_APP_ENV === "test" ? 1.0 : 0.2,
  environment:
    process.env.NEXT_PUBLIC_APP_ENV === "test" ? "development" : "production",
  integrations: [
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  beforeSend(event) {
    if (event.request?.headers?.Authorization) {
      delete event.request.headers.authorization;
    }

    if (event.extra?.authorization) {
      delete event.extra.authorization;
    }

    return event;
  },
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
